var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.correct && _vm.diff >= 1
    ? _c("KIcon", {
        style: { fill: _vm.$themeTokens.correct },
        attrs: { "data-testid": "correct-icon", icon: "plus" },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }